import React from "react";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Card from "../../components/Cards/Card";

export default function Faq({ app, config }) {
  return (
    <Card app={app} style={{ backgroundColor: "#ebf3fb", height: "100%" }}>
      <div className="container-titles">
        <h3 style={{ margin: "10px 0 34px" }}>Perguntas Frequentes</h3>
      </div>

      <div>
        <Accordion sx={{ fontFamily: "Public Sans", fontSize: "18px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontWeight: "bold", fontFamily: "Public Sans" }}
          >
            Qual é o período de apuração?{" "}
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: "16px" }}>
            Regra da periodicidade: Períodos são trimestrais, com apuração
            mensal e recuperação trimestral para as metas de Sell out,
            Distribuição TDP (Total Distributions Points) e Market Share. Outras
            metas não terão recuperação trimestral.  Data de previsão para
            início do primeiro trimestre: 01/07/2024  Data de término: sem
            previsão, valendo trimestralmente e prorrogável ao pedido da PRB.  
          </AccordionDetails>
        </Accordion>

        <Accordion sx={{ fontFamily: "Public Sans", fontSize: "18px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontWeight: "bold" }}
          >
            Como devo enviar minhas metas e meus resultados?{" "}
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: "16px" }}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt
            rem porro, totam ipsum recusandae dignissimos veniam eveniet
            deleniti excepturi consectetur laboriosam. Ipsam animi fugiat
            pariatur officiis deleniti blanditiis possimus necessitatibus?
          </AccordionDetails>
        </Accordion>

        <Accordion sx={{ fontFamily: "Public Sans", fontSize: "18px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontWeight: "bold", fontFamily: "Public Sans" }}
          >
            Qual é o critério utilizado nas pontuações?{" "}
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: "16px" }}>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Doloremque
            at id aliquid dolor quo cumque asperiores impedit labore incidunt,
            quam totam ipsam fuga voluptatibus a, maiores, quaerat itaque libero
            quisquam.
          </AccordionDetails>
        </Accordion>
      </div>
    </Card>
  );
}

Faq.defaultProps = {
  app: null,
  config: {},
};

Faq.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};
